import { AppBar, Box, BoxProps, IconButton, Typography } from "@mui/material"
import Logo from "./images/logo_img01.png"
import { Logout } from "@mui/icons-material"
import { useAuth0 } from "@auth0/auth0-react"
import { useWindowSize } from "../../functions/common"

export const Header = (props: BoxProps) => {
  const { width } = useWindowSize()
  const { logout } = useAuth0()
  const onLogoutButtonClick = () => {
    logout({ logoutParams: { returnTo: `${window.location.origin}/logout` } })
  }
  const fontFamily = [
    "メイリオ",
    "Meiryo",
    "ヒラギノ角ゴ Pro W3",
    "Hiragino Kaku Gothic Pro",
    "Osaka",
    "ＭＳ Ｐゴシック",
    "MS PGothic",
    "sans-serif"
  ]
  return (
    <Box {...props}>
      <AppBar component="header" position="relative" elevation={1} sx={{ borderWidth: 0, height: 64, backgroundColor: "transparent" }}>
        <Box display={"flex"} justifyContent={"space-between"}>
          <Box display={"flex"}>
            <Box
              component="img"
              sx={{ height: 64 }}
              alt="Logo"
              src={Logo}
              position={"relative"}
            />
            <Box alignContent={"center"} paddingLeft={2}>
              <Typography fontWeight={"bold"} fontSize={15} fontFamily={fontFamily} color="primary">
                {width >= 725 ? "買うほどおトク！5000円OFF＆最大20％ポイント還元キャンペーン応募フォーム" : "キャンペーン応募フォーム"}
              </Typography>
            </Box>
          </Box>
          <Box alignContent={"center"} justifyContent={"end"}>
            {<IconButton color="primary" sx={{ fontSize: 12 }} onClick={onLogoutButtonClick}><Logout />Logout</IconButton>}
          </Box>
        </Box>
      </AppBar>
    </Box>
  )
}

